RivalIQ.apps.Alerts.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    const eventDisplay = RivalIQ.utils.eventDisplay;

    views.FacebookAdsAlert = views.Alert.extend({
        getTemplate: function () {
            const me = this;
            const eventTypeId = me.model.get('event_type_id');
            const eventTypes = eventDisplay.eventTypes;

            switch (eventTypeId) {
                case eventTypes.facebookAdsUnderPerforming:
                    return '#alertsFacebookAdsUnderPerformingAlertTemplate';
                case eventTypes.facebookAdsTopPerformer:
                    return '#alertsFacebookAdsTopPerformerAlertTemplate';
                default:
                    throw new Error(`unknown Facebook Ad alert type ${eventTypeId}`);
            }
        },
        getLinkAdObject: function () {
            const me = this;

            const data = me.model.get('data');
            let adObject = _.get(data, ['adObject', 'adObject']);

            // if this is a breakdown we go to the campaign
            if (adObject.isBreakdown) {
                adObject = _.get(data, ['campaign', 'adObject']);
            }

            return adObject;
        },

        augmentTemplateData: function (data) {

            return App.utils.getFacebookAdsTemplateData(data, window.urlBasepath);

        }
    });

});
